export function formatFeeAmount(amount: string | number): string {
  const num = typeof amount === "string" ? parseFloat(amount) : Number(amount);

  if (isNaN(num)) {
    return "$0.00";
  }

  if (num === 0) {
    return "$0.00";
  }

  if (num < 0.01) {
    return "<$0.01";
  }

  return `$${num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
